<template>
    <div>
        <div class="rounded-md bg-office-primary-50 p-4 mb-2">
          <div class="flex justify-center">
            <div>Das neue Admin-Dashboard ist da!</div> <a class="font-bold ml-4" href="/admin-panel"> Hier klicken.</a>
          </div>
        </div>

        <headline>
            Dashboard
            <template v-slot:more>
                <schedule-create v-if="can.create.schedule" @created="reload"></schedule-create>
            </template>
        </headline>

        <loading v-show="loading"></loading>

        <schedule-error-warning></schedule-error-warning>

        <conference-room-request-warning></conference-room-request-warning>

        <div class="grid grid-cols-2 gap-4 mt-4 lg:grid-cols-3">
            
            <utilization v-if="can.create.schedule" @reload="load" class="col-span-3"></utilization>

            <info-statistics class="col-span-3"
                            :tenants="tenants"
                            :desks="desks"
                            :free="free"
                            :owners="owners"
                            :rooms="rooms"
                            :conferenceRooms="conferenceRooms"
            ></info-statistics>

            <div class="col-span-3 gap-4 grid grid-cols-3 grid-rows-2">

                <schedule-statistics
                    :current-renting-count="currentRentingCount"
                    :free="free"
                    :owners="owners"></schedule-statistics>

                <weekly-schedule class="col-span-2 row-span-2">
                    
                </weekly-schedule>

                <schedules-by-hour
                    :current-renting-count-by-hour="currentRentingCountByHour"
                    :free="freeAtThisMoment"
                    :owners="owners"
                ></schedules-by-hour>


            </div>

            <div class="lg:col-span-3 gap-4 lg:grid grid-cols-2">
                <schedule-errors></schedule-errors>
                <guest-bookings :schedules="schedules"></guest-bookings>
                <conference-room-requests></conference-room-requests>
            </div>

        </div>
    </div>
</template>

<script>
import Headline from "../components/UI/Headline.vue";
import Loading from "../components/UI/Loading.vue";
import ScheduleCreate from "../components/ScheduleCreate.vue";
import InfoStatistics from '../components/InfoStatistics.vue';
import WeeklySchedule from '../components/WeeklySchedule.vue';
import SchedulesByHour from "../components/SchedulesByHour.vue";
import ScheduleErrorWarning from "../components/ScheduleErrorWarning.vue";
import GuestBookings from "../components/GuestBookings.vue";
import ConferenceRoomRequests from "../components/ConferenceRoomRequests.vue";
import ConferenceRoomRequestWarning from "../components/ConferenceRoomRequestWarning.vue";

export default {
    name: "Dashboard",
    components: {
      ConferenceRoomRequestWarning,
      ConferenceRoomRequests,
      Loading,
      Headline,
      ScheduleCreate,
      InfoStatistics,
      WeeklySchedule,
      SchedulesByHour,
      ScheduleErrorWarning,
      GuestBookings,
    },
    inject: ['group','admin', 'can'],

    data: () => ({
        loading: true,
        tenants: [],
        owners: [],
        currentRentingCount: null,
        currentRentingCountByHour: null,
        desks: [],
        rooms: [],
        conferenceRooms: [],
        schedules: [],
        disabled: 0,
        releases: 0,
        releasesByCurrentHour: 0,

    }),

    mounted() {
        this.load();
    },

    created() {
        setInterval(this.load, 60000);
    },

    computed: {
        currentFixedDesks(){
          //fixed desks from users excluding those which are already released for this day
          return this.owners - this.releases;
        },

        free() {
            return this.desks - this.currentRentingCount - this.currentFixedDesks - this.disabled;
        },

        freeAtThisMoment() {
            return this.desks - this.currentRentingCountByHour - (this.owners - this.releasesByCurrentHour) - this.disabled;
        }
    },

    methods: {
        load() {
            this.$http.get('/admin/dashboard')
                .then(result => {
                    this.owners = result.data.owners;
                    this.tenants = result.data.tenants;
                    this.currentRentingCountByHour = result.data.currentRentingCountByHour;
                    this.currentRentingCount = result.data.currentRentingCount;
                    this.rooms = result.data.rooms;
                    this.conferenceRooms = result.data.conferenceRooms;
                    this.desks = result.data.desks;
                    this.disabled = result.data.disabled;
                    this.releases = result.data.releases;
                    this.releasesByCurrentHour = result.data.releasesByCurrentHour;
                    this.schedules = result.data.schedules;
                    this.loading = false;
                }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
        reload() {
            location.reload();
        },
    }
}
</script>

<style scoped>

</style>
